import {
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  TextField,
  Select,
  MenuItem,
} from "@mui/material";
import { lightBlue } from "@mui/material/colors";

function ClassesTable({
  rows,
  classes,
  selectedCampus,
  loading,
  onSort,
  onSelectStudent,
  onClassChange,
  onSaveChanges,
}) {
  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 800 }} size="small" aria-label="Class Assignment Table">
        <TableHead>
          <TableRow sx={{ bgcolor: lightBlue[100], border: 1.5 }}>
            <TableCell align="center">
              <strong></strong>
            </TableCell>
            <TableCell align="center">
              <strong>ID</strong>
            </TableCell>
            <TableCell align="center">
              <strong>Surname</strong>
            </TableCell>
            <TableCell align="center">
              <strong>Forename</strong>
            </TableCell>
            <TableCell
              align="center"
              onClick={() => onSort("student_age")}
              sx={{ cursor: "pointer" }}
            >
              <strong>Age</strong>
            </TableCell>
            <TableCell
              align="center"
              onClick={() => onSort("english_level")}
              sx={{ cursor: "pointer" }}
            >
              <strong>Level</strong>
            </TableCell>
            <TableCell align="center">
              <strong>Nationality</strong>
            </TableCell>
            <TableCell align="center">
              <strong>Class</strong>
            </TableCell>
            <TableCell align="center">
              <strong>Teacher</strong>
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {rows.map((student, idx) => {
            const matchedGroup =
  classes.find((cls) => String(cls.id) === String(student.group_id)) ||
  classes.find(
    (cls) =>
      String(cls.groupName || "").trim().toLowerCase() ===
      String(student.group_name || "").trim().toLowerCase()
  );

            return (
              <TableRow
                key={student.studentId}
                sx={
                  student.group_name === "none"
                    ? { backgroundColor: "#fffbe6" }
                    : {}
                }
              >
                <TableCell align="center">{idx + 1}</TableCell>

                <TableCell
                  align="center"
                  sx={{
                    cursor: "pointer",
                    color: "blue",
                    textDecoration: "underline",
                  }}
                  onClick={() => onSelectStudent(student.studentId)}
                >
                  {student.studentId}
                </TableCell>

                <TableCell align="center">{student.student_surname}</TableCell>
                <TableCell align="center">{student.student_name}</TableCell>
                <TableCell align="center">{student.student_age}</TableCell>
                <TableCell align="center">{student.english_level}</TableCell>
                <TableCell align="center">{student.student_nationality}</TableCell>

                <TableCell align="center">
                  <TextField
                    size="small"
                    value={student.group_name || ""}
                    onChange={(e) =>
                      onClassChange(student.studentId, "group_name", e.target.value)
                    }
                    disabled={!selectedCampus}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        onSaveChanges();
                      } else if (e.key === "Tab") {
                        e.preventDefault();
                        const next = document.querySelector(
                          `[data-tabindex="class-${idx + 1}"]`
                        );
                        if (next) next.focus();
                      }
                    }}
                    inputProps={{
                      "data-tabindex": `class-${idx}`,
                    }}
                  />
                </TableCell>

                <TableCell align="center">
  <Select
    size="small"
    value={matchedGroup?.leaderName || student.adult_full_name || ""}
    onChange={(e) =>
      onClassChange(
        student.studentId,
        "adult_full_name",
        e.target.value
      )
    }
    disabled={!selectedCampus}
    displayEmpty
    sx={{ minWidth: 180 }}
    renderValue={() =>
      matchedGroup?.leaderName || student.adult_full_name || "No Teacher"
    }
  >
    <MenuItem value="">No Teacher</MenuItem>

    {selectedCampus &&
      classes.map((cls) => {
        const teacherName = cls.leaderName;
        if (!teacherName) return null;

        return (
          <MenuItem key={`${cls.id}-${teacherName}`} value={teacherName}>
            {teacherName}
          </MenuItem>
        );
      })}
  </Select>
</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default ClassesTable;